import {Product} from './product';
import {Company} from './company';
import {Country} from './country';
import {AppIdentityUserLight} from './app-identity-user-light';

export class PartnerCounter {
  companyId: number;
  company: Company;

  code: string;
  year: number;
  month: number;
  numberOfActions: number;
  amount: number;
  productId: number;
  product: Product;

}

export class PartnerCounterCompany {
  rawCounters: PartnerCounter[];
  companyCounters: PartnerCounter[]; // the sum of the raw counters
}

export class PartnerInvoice {
  companyId: number;
  company: Company;

  invoiceNumber: string;

  recipientCompanyName: string;
  recipientAddress: string;
  recipientPostCode: string;
  recipientCity: string;
  recipientCountry: Country;

  recipientVatId: string;

  senderCompanyName: string;
  senderAddress: string;
  senderPostCode: string;
  senderCity: string;
  senderCountry: Country;

  senderVatId: string;

  createDate: Date;
  invoiceDate: Date;
  invoicePeriodFrom: Date|null;
  invoicePeriodTo: Date|null;
  sendDate: Date | null;

  netAmount: number;
  grossAmount: number;

  commissionNetAmount: number;
  commissionGrossAmount: number;

  statementNetAmount: number;
  statementGrossAmount: number;


  paidAmount: number;

  reminderLevel: number;
  reminderFee: number;

  isFinished: boolean;
  isPaid: boolean;

  lineItems: PartnerInvoiceLineItem[];
  id: number|null;

}

export class PartnerInvoiceLineItem {
  partnerMonthInvoiceId: number;
  partnerInvoice: PartnerInvoice;

  sortOrder: number;

  code: string;
  description: string;

  netAmountPerItem: number;
  numberOfItems: number;

  vatRate: number;
  currencyCode: number;

  isEdited: boolean;
  editDate: Date | null;
  ditUserId: string;
  editUser: AppIdentityUserLight;

  needsUserInput: boolean;

  type: number; // 1 = invoice, 2 = commission
  amountCalcBase: number;

}
